$(function() {
  let curDetailElement = null
  $('nav.header__inline-menu>ul.list-menu.list-menu--inline>li').on('mouseenter', function(event) {
    curDetailElement?curDetailElement.removeAttr('open'):null;
    var firstChildTag = $(this).children().first().prop('tagName');
    if (firstChildTag === 'HEADER-MENU') {
      var detailsElement = $(this).find('details').eq(0);
      curDetailElement=detailsElement
      if (event.type === 'mouseenter') {
        detailsElement.attr('open', true);
      }
    }
  });
  $("header.header").on("mouseleave",function(){
    curDetailElement?curDetailElement.removeAttr('open'):null;
  })
});